import { render } from "./TrfModalCadastroTarefas.vue?vue&type=template&id=6ea6ddd0&scoped=true"
import script from "./TrfModalCadastroTarefas.vue?vue&type=script&lang=js"
export * from "./TrfModalCadastroTarefas.vue?vue&type=script&lang=js"

import "./TrfModalCadastroTarefas.vue?vue&type=style&index=0&id=6ea6ddd0&lang=scss&scoped=true"
import "./TrfModalCadastroTarefas.vue?vue&type=style&index=1&id=6ea6ddd0&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea6ddd0"],['__file',"src/components/Modal/TrfModalCadastroTarefas.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ea6ddd0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ea6ddd0', __exports__)) {
    console.log('reload')
    api.reload('6ea6ddd0', __exports__)
  }
  
  module.hot.accept("./TrfModalCadastroTarefas.vue?vue&type=template&id=6ea6ddd0&scoped=true", () => {
    console.log('re-render')
    api.rerender('6ea6ddd0', render)
  })

}


export default __exports__